<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>充值审批</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <div class="page-actions">
        <el-select v-model="auditStatus" placeholder="状态" @change="handleSearch">
          <el-option value>请选择审批状态</el-option>
          <el-option v-for="key in Object.keys(STATUS_TYPES)" :key="key" :label="STATUS_TYPES[key].text"
            :value="key"></el-option>
        </el-select>
        <el-date-picker v-model="value2" type="daterange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <a @click="getExcel" target="_blank">导出Excel</a>
      </div>
      <audit-list @refresh="refreshList($event)"></audit-list>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions } from "vuex";
import AuditList from "./components/list";
import { STATUS_TYPES } from './constants';

export default {
  name: "loglim",
  data() {
    return {
      STATUS_TYPES,
      auditStatus: '0',
      fromUid: '',
      toUserId: '',
      value2: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  components: {
    AuditList
  },
  computed: {
    ...mapState('deposite', ['pagination'])
  },
  methods: {
    ...mapActions("deposite", ["list", 'exportExcel']),
    handleSearch() {
      this.list({
        endTime: this.value2 ? this.value2[1].valueOf() : '',
        startTime: this.value2 ? this.value2[0].valueOf() : '',
        auditStatus: this.auditStatus
      });
    },
    refreshList({ type, pagination }) {
      this.list({
        endTime: this.value2 ? this.value2[1].valueOf() : '',
        startTime: this.value2 ? this.value2[0].valueOf() : '',
        auditStatus: type, ...pagination
      })
    },
    getExcel() {
      this.exportExcel({
        endTime: this.value2 ? this.value2[1].valueOf() : '',
        startTime: this.value2 ? this.value2[0].valueOf() : '',
        auditStatus: this.auditStatus
      }).then(res => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
        link.style.display = 'none'
        // 设置连接
        link.href = URL.createObjectURL(blob)  //将文件流转化为blob地址
        console.log('link-href', link.href);
        link.download = '充值审批统计报表'
        document.body.appendChild(link)
        // 模拟点击事件
        link.click()  //设置点击事件

      });
    }
  },
  mounted() {
    this.list();
  }
};
</script>

<style lang="less" scoped></style>
